import { classNames } from "@utils/classNames";
import React, { FC } from "react";
import { AssignedTag, NewTag } from "types/tags";

interface Props {
  tags?: (AssignedTag & NewTag)[];
  cN?: string;
  tagCN?: string;
}

export const TagsBlock: FC<Props> = ({ tags = [], cN, tagCN }) => {
  return (
    <div className={classNames(cN)}>
      {tags.map(({ id, label }, index) => (
        <a key={id || index} href={`/search?tags=${id}`} rel="nofollow">
          <span className={classNames(tagCN, "hover:bg-gray-200")}>{label || id}</span>
        </a>
      ))}
    </div>
  );
};
